import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, GridLegacy as Grid } from "@mui/material";
import { FC, useEffect } from "react";
import { useTranslation } from 'react-i18next';

import { ICriteria } from "./common/types";
import { useUserParams } from '@/context/user-params-context';

interface ISellableDaysCriteriaConfig {
    defaultValue?: number;
    minValue?: number;
    maxValue?: number;
    allowedValues?: number[];
}

export const SellableDaysSelector: FC<ICriteria<ISellableDaysCriteriaConfig>> = ({ config }) => {
    const { userParams, setUserParams, clearParams } = useUserParams();
    const { t } = useTranslation();

    const defaultValue = config?.defaultValue ?? 3;
    const minValue = config?.minValue ?? 1;
    const maxValue = config?.maxValue ?? 30;
    const allowedValues = config?.allowedValues ?? Array.from({ length: maxValue - minValue + 1 }, (_, i) => minValue + i);

    useEffect(() => {
        setUserParams({ "@u_daysToSell": defaultValue });

        return () => {
            clearParams(['@u_daysToSell']);
        };
    }, []);

    const handleChange = ({ target: { value } }: SelectChangeEvent) => {
        setUserParams({ "@u_daysToSell": Number(value) });
    };

    return (
        <Grid item sm={4} md={2}>
            <FormControl fullWidth size="small" sx={{ minWidth: 160 }}>
                <InputLabel id="sellable-days-select-label">
                    {t("input.criteria.labels.sellableDays")}
                </InputLabel>
                <Select
                    labelId="sellable-days-select-label"
                    id="sellable-days-select"
                    value={String(userParams["@u_daysToSell"] ?? defaultValue)}
                    label={t("input.criteria.labels.sellableDays")}
                    onChange={handleChange}
                >
                    {allowedValues.map((value) => (
                        <MenuItem key={value} value={value}>
                            {value} {value === 1 ? t("input.criteria.options.day") : t("input.criteria.options.days")}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Grid>
    );
};

export default SellableDaysSelector; 